var $scroll = {
  // ======================================================================
  // OPTIONS
  // ======================================================================

  use: false,

  maxDelta: 400, //40, // max wheel scroll speed limit (breaks on windows)
  wheelMultiply: 2.5, // wheel scroll speed multiplier
  touchMultiplyX: 2, // touch scroll speed X multiplier
  touchMultiplyY: 3, // touch scroll speed Y multiplier
  lockDist: 30, // swipe distance after which to lock the direction

  timeWheelAnimate: 0.1, // duration for wheel scroll to animate page position
  timeTouchAnimate: 0.5, // duration for touch scroll to animate page position
  timeProgressChangeOut: 0.5, // duration for progress bar to hide before page transition
  timeProgressChangeIn: 0.8, // duration for progress bar to show after page transition

  // ======================================================================
  // VARS
  // ======================================================================

  inited: false, // store whether init has run
  enabled: false, // store whether scrolling is currently enabled
  enabledProgress: true, // store whether the progress bar can be resized
  currentPage: null, // store current page id

  touchXOrig: 0, // store touchstart x position
  touchYOrig: 0, // store touchstart y position
  touchXCurrent: 0, // store touchmove x position
  touchYCurrent: 0, // store touchmove y position
  touchMoved: false, // store whether a touch actually moved the page

  locked: false, // store current swipe lock direction
  lockXOrig: null, // store locked touchstart x position
  lockYOrig: null, // store locked touchstart y position
  lockXCurrent: 0, // store locked touchmove x position
  lockYCurrent: 0, // store locked touchmove y position

  pages: {}, // object that stores various page data
  observer: null, // store intersection observer for fixed nav position
  navLocked: false, // store whether nav has been scrolled and locked to side of page

  // ======================================================================
  // INIT
  // ======================================================================

  init: function() {
    // determine whether to use js scrolling
    if (!$device.isTouchScreen) {
      $scroll.use = true;
    }
    // initialise depending on scroll type
    if ($scroll.use) {
      $scroll.initJS();
    } else {
      $scroll.initDefault();
    }
  },

  initJS: function() {
    $scroll.resize();
    $el('body').addClass('js-init-scroll js-init-scroll-js');

    $el('body').mousewheel(function(event, delta) {
      if ($windowsize.isDesktop && $scroll.enabled) {
        try {
          event.preventDefault();
        } catch (e) {}
        $scroll.wheel(event.deltaY * event.deltaFactor);
      }
    });

    $(window).on('touchstart', function(event) {
      if ($windowsize.isDesktop && $scroll.enabled) {
        event.preventDefault();
        // log that user is currently touching
        $scroll.touching = true;
        // log start touch coordinates
        $scroll.touchXOrig = event.originalEvent.touches[0].pageX;
        $scroll.touchYOrig = event.originalEvent.touches[0].pageY;
      }
    });

    $(window).on('touchmove', function(event) {
      if ($windowsize.isDesktop && $scroll.enabled && $scroll.touching) {
        event.preventDefault();
        if (!$scroll.locked) {
          // log current touch coordinates
          $scroll.touchXCurrent = $scroll.touchXOrig - event.originalEvent.touches[0].pageX;
          $scroll.touchYCurrent = $scroll.touchYOrig - event.originalEvent.touches[0].pageY;
        } else {
          // log locked start touch coordinates
          if ($scroll.lockXOrig === null) {
            $scroll.lockXOrig = event.originalEvent.touches[0].pageX;
            $scroll.lockYOrig = event.originalEvent.touches[0].pageY;
          } else {
            $scroll.lockXCurrent = $scroll.lockXOrig - event.originalEvent.touches[0].pageX;
            $scroll.lockYCurrent = $scroll.lockYOrig - event.originalEvent.touches[0].pageY;
          }
        }
        // render
        $scroll.touch();
        // log that user has moved
        $scroll.touchMoved = true;
      }
    });

    $(window).on('touchend', function() {
      if ($windowsize.isDesktop && $scroll.enabled && $scroll.touching) {
        if ($scroll.touchMoved) {
          var pageObject = $scroll.pages[$scroll.currentPage];
          // render
          $scroll.touch();
          // save new scroll position
          pageObject.scrollPos = $scroll.touchPos();
          // log that user has stopped touching
          $scroll.touching = false;
          // reset things
          $scroll.touchMoved = false;
        }
        // reset scroll lock
        $scroll.locked = false;
        $scroll.lockXOrig = null;
        $scroll.lockYOrig = null;
        $scroll.lockXCurrent = 0;
        $scroll.lockYCurrent = 0;
      }
    });

    $scroll.observeInit();
    $scroll.inited = true;
  },

  initDefault: function() {
    $el('body').addClass('js-init-scroll js-init-scroll-default');
    $scroll.observeInit();
    $scroll.inited = true;
  },

  // ======================================================================
  // ENABLE / DISABLE
  // ======================================================================

  // in case you want to prevent the user from scrolling,
  // e.g. during a page transition
  enable: function() {
    $scroll.enabled = true;
  },

  disable: function() {
    $scroll.enabled = false;
  },

  enableAfterIntro: function() {
    $scroll.resize();
    $scroll.enabled = true;
  },

  // ======================================================================
  // WHEEL
  // ======================================================================

  wheel: function(delta) {
    if ($scroll.currentPage !== null) {
      var pageObject = $scroll.pages[$scroll.currentPage];

      // limit max scroll speed
      if (delta > $scroll.maxDelta) {
        delta = $scroll.maxDelta;
      } else if (delta < -$scroll.maxDelta) {
        delta = -$scroll.maxDelta;
      }

      // calculate new scroll position
      var scrollPos = pageObject.scrollPos - delta * $scroll.wheelMultiply;

      // limit to min / max position (don't overscroll)
      if (scrollPos < 0) {
        scrollPos = 0;
      } else if (scrollPos > pageObject.maxWidth) {
        scrollPos = pageObject.maxWidth;
      }

      // save new scroll position
      pageObject.scrollPos = scrollPos;

      // render
      $scroll.render(pageObject.scrollPos, false);
    }
  },

  // ======================================================================
  // TOUCH
  // ======================================================================

  touchPos: function() {
    var pageObject = $scroll.pages[$scroll.currentPage];
    var distX = -$scroll.touchXCurrent;
    var distY = $scroll.touchYCurrent;
    var scrollPos;

    // unlocked scrolling
    if (!$scroll.locked) {
      // calculate scroll direction
      var scrollDir;
      var swipeDir;
      var angle = toDegrees(Math.atan(Math.abs(distY) / Math.abs(distX)));
      if (distX >= 0 && distY >= 0) {
        if (angle >= 45) {
          // angle = 0° - 45°
          scrollDir = 'left';
          swipeDir = 'vertical';
        } else {
          // angle = 45° - 90°
          scrollDir = 'right';
          swipeDir = 'horizontal';
        }
      } else if (distX >= 0 && distY < 0) {
        if (angle < 45) {
          // angle = 90° - 135°
          scrollDir = 'right';
          swipeDir = 'horizontal';
        } else {
          // angle = 135° - 180°
          scrollDir = 'right';
          swipeDir = 'vertical';
        }
      } else if (distX < 0 && distY < 0) {
        if (angle >= 45) {
          // angle = 180° - 225°
          scrollDir = 'right';
          swipeDir = 'vertical';
        } else {
          // angle = 225° - 270°
          scrollDir = 'left';
          swipeDir = 'horizontal';
        }
      } else if (distX < 0 && distY >= 0) {
        if (angle < 45) {
          // angle = 270° - 315°
          scrollDir = 'left';
          swipeDir = 'horizontal';
        } else {
          // angle = 315° - 360°
          scrollDir = 'left';
          swipeDir = 'vertical';
        }
      }

      // calculate scroll distance
      var distance = Math.sqrt(distX * distX + distY * distY);

      // calculate new scroll position
      scrollPos =
        pageObject.scrollPos +
        (scrollDir === 'left' ? distance : -distance) *
          (swipeDir === 'horizontal' ? $scroll.touchMultiplyX : $scroll.touchMultiplyY);
    }

    // locked scrolling
    else {
      if ($scroll.locked === 'horizontal') {
        scrollPos = pageObject.scrollPos + $scroll.lockXCurrent * $scroll.touchMultiplyX;
      } else {
        scrollPos = pageObject.scrollPos + $scroll.lockYCurrent * $scroll.touchMultiplyY;
      }
    }

    // limit to min / max position (don't overscroll)
    if (scrollPos < 0) {
      scrollPos = 0;
    } else if (scrollPos > pageObject.maxWidth) {
      scrollPos = pageObject.maxWidth;
    }

    // lock swipe direction
    if (!$scroll.locked && distance > $scroll.lockDist) {
      $scroll.locked = swipeDir;
      pageObject.scrollPos = scrollPos;
    }

    // return new scroll position
    return scrollPos;
  },

  touch: function() {
    // get scroll position
    var scrollPos = $scroll.touchPos();

    // render
    $scroll.render(scrollPos, true);
  },

  // ======================================================================
  // RENDER (i.e. apply the scroll)
  // ======================================================================

  render: function(scrollPos, touch, page, duration, ease) {
    var currentPage = page !== null && typeof page !== 'undefined' ? page : $scroll.currentPage;
    var pageObject = $scroll.pages[currentPage];

    // if page is narrower than window, don't do anything
    if (pageObject.maxWidth < 0 && scrollPos != 0) {
      return false;
    }

    // determine gsap function - depending on whether immediate or animated
    var gsapFunc = $scroll.inited ? gsap.to : gsap.set;

    // animation duration
    var animationDuration = duration ? duration : touch ? $scroll.timeTouchAnimate : $scroll.timeWheelAnimate;

    // animate progress bar
    $scroll.renderProgressBar(pageObject, scrollPos, animationDuration);

    // animate scroll position
    gsapFunc($el('#' + currentPage + ' .page__scroll'), {
      scrollTo: {x: scrollPos},
      duration: animationDuration,
      ease: ease || Power1.easeOut
    });

    // animate nav bar position
    if (pageObject.hasOffset && !$scroll.navLocked) {
      var navX = pageObject.contentOffset - scrollPos;
      if (navX > -500) {
        gsapFunc($el('#nav'), {
          x: Math.round(navX),
          duration: animationDuration,
          ease: ease || Power1.easeOut
        });
      }
    }
  },

  renderProgressBar: function(pageObject, scrollPos, duration) {
    if ($scroll.enabledProgress) {
      // calculate scrolled percentage
      var scrollPercent = (scrollPos - pageObject.contentOffset) / (pageObject.maxWidth - pageObject.contentOffset);
      if (scrollPercent < 0) {
        scrollPercent = 0;
      }

      // animate progress bar
      gsap.to($el('.progress__bar'), {
        scaleX: scrollPercent,
        duration: duration
      });
    }
  },

  renderAfterTransition: function() {
    // console.log('%c--- renderAfterTransition ---', 'color:#179ea2');
    var pageObject = $scroll.pages[$scroll.currentPage];
    $scroll.renderProgressBar(pageObject, pageObject.scrollPos, $scroll.timeProgressChangeIn);
  },

  // ======================================================================
  // SCROLL OBSERVER
  // ======================================================================

  observeInit: function() {
    $scroll.observeRun();
  },

  observeEnd: function() {
    if ($scroll.observer !== null) {
      $scroll.observer.disconnect();
      $scroll.observer = null;
    }
  },

  observeRun: function() {
    $scroll.observeEnd();
    if (!$scroll.navLocked) {
      var stickyElm = $('.page--current .page__nav')[0];
      if (typeof stickyElm !== 'undefined') {
        $scroll.observer = new IntersectionObserver(
          function(event) {
            $scroll.observeToggle(event[0].intersectionRatio);
          },
          {
            threshold: [1]
          }
        );
        $scroll.observer.observe(stickyElm);
      }
    }
  },

  observeToggle: function(ratio) {
    if (ratio < 1) {
      if ($windowsize.isDesktop && $device.isTouchScreen) {
        gsap.fromTo(
          $el('.nav__logo'),
          1,
          {
            opacity: 0
          },
          {
            opacity: 1
          }
        );
      }
      $el('body').addClass('js-has-scrolled');
      $scroll.navLocked = true;
      $scroll.observeEnd();
    }
  },

  // ======================================================================
  // RESIZE
  // ======================================================================

  // on page resize, recalculate scroll container dimensions
  resize: function() {
    if ($scroll.use) {
      // console.log('%c--- resize ---', 'color:#179ea2');
      $('.page').each(function() {
        var id = $(this).attr('id');
        if (typeof $scroll.pages[id] === 'undefined') {
          $scroll.pages[id] = {
            scrollPos: 0
          };
        }
        // when landing on a primary page, nav starts at an offset position
        $scroll.pages[id].hasOffset =
          $el('#' + id).hasClass('page--offset-nav') && $el('#' + id).hasClass('page--landing');
        // get various dimensions
        $scroll.pages[id].navWidth = $el('#' + id + ' .page__nav').outerWidth();
        $scroll.pages[id].heroWidth = $el('#' + id + ' .page__hero').is(':visible')
          ? $el('#' + id + ' .page__hero').outerWidth()
          : 0;
        $scroll.pages[id].bodyWidth = $el('#' + id + ' .page__body').outerWidth();
        $scroll.pages[id].maxWidth =
          $scroll.pages[id].navWidth + $scroll.pages[id].heroWidth + $scroll.pages[id].bodyWidth - $windowsize.w;
        $scroll.pages[id].contentOffset = $scroll.pages[id].hasOffset ? $scroll.pages[id].heroWidth : 0;
      });
      $scroll.wheel(0);
      if ($nav.visible) {
        $scroll.scrollToNav();
      }
    }
  },

  // render scroll position for all pages
  resizeAllScrollPositions: function() {
    if ($scroll.use) {
      // console.log('%c--- resizeAllScrollPositions ---', 'color:#179ea2');
      for (var page in $scroll.pages) {
        var pageObject = $scroll.pages[page];
        $scroll.render(pageObject.scrollPos, false, page, 0);
      }
    }
  },

  // resize new page after a page transition
  resizeNewPage: function() {
    if ($scroll.use) {
      // console.log('%c--- resizeNewPage ---', 'color:#179ea2');
      $scroll.enabledProgress = false;
      gsap.to($el('.progress__bar'), {
        scaleX: 0,
        duration: $scroll.timeProgressChangeOut
      });
      $scroll.resize();
      $scroll.resizeAllScrollPositions();
    }
  },

  // ======================================================================
  // PAGE FUNCTIONS
  // ======================================================================

  // instantly set the currently scrolling page
  setPage: function(page) {
    $scroll.currentPage = page;
  },

  // after page transition, set the new page and apply changes
  setNewPage: function(page) {
    if ($scroll.use) {
      $scroll.currentPage = page;
      $scroll.enabledProgress = true;
      $scroll.observeRun();
      $scroll.renderAfterTransition();
      $scroll.enable();
    }
  },

  // reset the scroll position of a page to 0
  resetPageScrollPos: function(page) {
    if ($scroll.use) {
      // desktop
      $scroll.pages[page].scrollPos = 0;
      $scroll.render(0, false, page, 0);
      // mobile
      $('#' + page + ' .page__scroll')
        .scrollTop(0)
        .scrollLeft(0);
    } else {
      $('#' + page + ' .page__scroll')
        .scrollTop(0)
        .scrollLeft(0);
    }
  },

  // scroll to nav bar
  scrollToNav: function(callback) {
    if ($scroll.use) {
      if (!$scroll.navLocked) {
        var pageObject = $scroll.pages[$scroll.currentPage];
        var scrollPos = pageObject.scrollPos;
        var navPos = pageObject.contentOffset;
        if (navPos > scrollPos) {
          var dif = navPos - scrollPos;
          var t = dif * 0.0009;
          if (t < 0.6) {
            t = 0.6;
          } else if (t > 1) {
            t = 1;
          }
          $scroll.pages[$scroll.currentPage].scrollPos = navPos;
          $scroll.render(navPos, false, null, t, Power2.easeInOut);
          if (typeof callback === 'function') {
            setTimeout(function() {
              callback();
            }, t * 1100);
          }
          return;
        }
      }
      if (typeof callback === 'function') {
        callback();
      }
    } else {
      if (typeof callback === 'function') {
        callback();
      }
    }
  },

  // ======================================================================
  // MISC HELPERS
  // ======================================================================

  getScrollPos: function() {
    return $scroll.pages[$scroll.currentPage];
  }
};
